var map = {
	"./1.jpg": 5183,
	"./2.jpg": 1568,
	"./3.jpg": 2701,
	"./a.png": 5791,
	"./bg_basic_comp.jpg": 6022,
	"./bg_inners_comp.jpg": 159,
	"./bg_innovations_comp.jpg": 7340,
	"./bg_services_comp.jpg": 2058,
	"./chips_comp.mp4": 5541,
	"./cloud.png": 153,
	"./cloud2.png": 4111,
	"./dash2.png": 7292,
	"./dashboard.jpg": 6222,
	"./dd_comp.mp4": 1196,
	"./error.png": 6080,
	"./headphone.png": 7160,
	"./home1.png": 3060,
	"./home2.png": 6623,
	"./homeVideo1.png": 6391,
	"./homeVideo2.png": 9356,
	"./homeVideo3.png": 981,
	"./latest1.png": 2980,
	"./latest2.png": 8255,
	"./latest3.png": 806,
	"./logo_comp 01.52.10.mp4": 2178,
	"./main_sphere 01.52.10.mp4": 654,
	"./phones.png": 6503,
	"./rings_comp.mp4": 649,
	"./service1.png": 1446,
	"./service2.png": 6333,
	"./service3.png": 5204,
	"./service4.png": 1115,
	"./service5.png": 9986,
	"./service6.png": 4521,
	"./soft.png": 5828,
	"./sphere.png": 1139,
	"./success.png": 5027,
	"./user.png": 9749,
	"./user2.png": 4371,
	"./user3.png": 2794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;